import { isMobile } from "../utils";
import pcView from "./pc";
import mobileView from "./mobile";
var CnErrorFeedback = {
  show: function show(errorConstructInfo) {
    if (isMobile()) {
      return mobileView.show(errorConstructInfo);
    } else {
      return pcView.show(errorConstructInfo);
    }
  }
};
export default CnErrorFeedback;